import styled from 'styled-components';

export const AddressesContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
`;

export const TabsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  padding: 0 24px 0 0;
  border-bottom: 1px solid #e5e7eb;
`;

export const TabsList = styled.div`
  display: flex;
  gap: 0;
  overflow-x: auto;
  align-items: center;

  &::-webkit-scrollbar {
    height: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #d1d5db;
    border-radius: 2px;
  }
`;

export const Tab = styled.button`
  padding: 16px 14px;
  background: none;
  border: none;
  color: ${({ $active }) => ($active ? '#2563eb' : '#6b7280')};
  font-size: 14px;
  font-weight: ${({ $active }) => ($active ? '600' : '500')};
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s ease;
  position: relative;

  &:hover {
    color: #2563eb;
  }
`;

export const TabSeparator = styled.div`
  width: 20px;
  height: 4px;
  background-color: ${({ $active }) => ($active ? '#296BCD' : '#E2E8F0')};
  border-radius: 2px;
  transition: background-color 0.2s ease;
`;

export const AddButtonWrapper = styled.div`
  padding: 12px 0;
`;

export const AddressesContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: #fff;
  padding: 24px;
  min-height: 400px;
  flex: 1;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const TableHead = styled.thead`
  border-bottom: 1px solid #e5e7eb;
`;

export const TableBody = styled.tbody``;

export const TableRow = styled.tr`
  border-bottom: 1px solid #f3f4f6;

  &:hover {
    background-color: #f9fafb;
  }
`;

export const TableHeader = styled.th`
  text-align: left;
  padding: 12px 16px;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
`;

export const TableCell = styled.td`
  padding: 16px;
  font-size: 14px;
  color: #1f2937;
`;

export const ActionsCell = styled(TableCell)`
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: flex-end;
`;

export const IconButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.7;
  }

  svg {
    width: 18px;
    height: 18px;
  }
`;

export const EmptyState = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 300px;
  font-size: 14px;
  color: #6b7280;
`;

export const LoadingSpinner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 300px;
  font-size: 14px;
  color: #6b7280;
`;

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 24px;
  width: 100%;
`;

export const ConfirmMessage = styled.p`
  font-size: 14px;
  color: #374151;
  margin: 0;
  line-height: 1.5;

  strong {
    color: #1f2937;
    font-weight: 600;
  }
`;

export const ModalContent = styled.div`
  padding: 8px 0;
`;

export const FilterSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  max-width: 100%;
  padding-bottom: ${({ $noBorder }) => ($noBorder ? '0' : 'initial')};
  border-bottom: ${({ $noBorder }) => ($noBorder ? 'none' : 'initial')};
`;

export const FilterFlex = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  max-width: 100%;
`;

export const TableHeaderActions = styled(TableHeader)`
  width: 100px;
  text-align: right;
`;

export const ModalFormContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
